export enum BankAccountFormatType {
  CZECH = "CZECH",
  IBAN = "IBAN",
  OTHER = "OTHER",
}
